import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.core').factory('LegalEntityDA', LegalEntityDA);

    LegalEntityDA.$inject = ['Restangular', 'CONF'];

    /**
     * Class permettant la manipulation des infos relatives aux sociétés.
     */

    /* @ngInject */
    function LegalEntityDA(Restangular, CONF) {
        var baseUrl = CONF.apiBaseUrl + '/v1/legal-entity';

        var exports = {
            isCompanyDeletable: isCompanyDeletable,
            deleteCompany: deleteCompany,
            getSubEntityRejectionInfo:getSubEntityRejectionInfo
        };

        return exports;

        ////////////////
        /**
         * Retourne True si la société est supprimable.
         */
        function isCompanyDeletable(legalEntityId) {
            return Restangular.one(baseUrl, legalEntityId)
                .one('deletable')
                .get();
        }

        /**
         * Supprime une société vide.
         */
        function deleteCompany(legalEntityId) {
            return Restangular.one(baseUrl, legalEntityId).remove();
        }

        function getSubEntityRejectionInfo(subEntityId){
            return Restangular.one(baseUrl+'/sub-entity/rejection-info/'+ subEntityId)
            .get()
            .then(function (data) {
                return data;
            });
        }
    }
    
})();
